import { render, staticRenderFns } from "./CustomRadialChart.vue?vue&type=template&id=213aa660&scoped=true&"
import script from "./CustomRadialChart.vue?vue&type=script&lang=js&"
export * from "./CustomRadialChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomRadialChart.vue?vue&type=style&index=0&id=213aa660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213aa660",
  null
  
)

export default component.exports